/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import { flushSync } from 'react-dom';
import {
  Form,
  Row,
  Spin,
  Col,
  Card,
  Input,
  Button,
  Menu,
  Modal,
  Tabs,
  Checkbox,
  Progress,
  notification,
  Select as AntdSelect,
  Empty,
  Typography,
  Tag,
} from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';
import {
  FileExcelOutlined,
  DownloadOutlined,
  EditOutlined,
  CheckCircleOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { selectUser } from 'store/auth';
import { onError } from 'utils/handlers';
import { postObtenerReporte } from 'api/reporteador';
import Dragger from 'components/Dragger';
import HTTP, { baseURL } from 'utils/api';
import { API_HOST } from 'utils/env';
import Table from 'components/Table';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import CRUDgeneric from 'utils/CRUDgeneric';
import moment from 'moment';
import ModalDelete from 'components/ModalDelete';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getEmpleado, getEmpleadosvistaOptimized } from 'api/estructuraOrganizacional/empleados';
import { getEstadosDeEmpleados } from 'api/estructuraOrganizacional/estadosDeEmpleados';
import { postActualizarAntiguedad } from 'api/nominas/vacaciones/vacacionesActualizarAntiguedad';
import { getEstadosGlobales } from 'api/catalogos';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_CANCELADO,
  TIPO_DE_FUNCION_JUBILADO,
  TIPO_DE_FUNCION_PENSIONADO,
} from 'utils/constants';

// Components
import { getVacacionesPlantillaExcel } from 'api/nominas/vacaciones/vacacionesEmpleadosDiasDisfrutados';
import { getVacacionesEmpleadosPeriodos } from 'api/nominas/vacaciones/vacacionesEmpleadosPeriodos';
import { getGuardiasVacacionalesGeneral } from 'api/configuraciones/ConfigurarGuardiasVacacionales/ConfigurarGuardiasVacacionalesGeneral';
import { getGuardiasVacacionalesPeriodos } from 'api/configuraciones/ConfigurarGuardiasVacacionales/ConfigurarGuardiasVacacionalesPeriodos';
import { obtenerRegistrosDe } from 'utils/URIsSac';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import VacacionesRegistrosEmpleados from './VacacionesRegistrosEmpleados';
import VacacionesRegistrosEmpleados2 from './VacacionesRegistrosEmpleados2';

const DESCRIPCION_PROCESO_IMPORTAR_VACACIONES = 'Importar Vacaciones Empleados';
const DESCRIPCION_PROCESO_ACTUALIZAR_ANTIGUEDAD = 'Actualización de Antigüedad y Vacaciones';

const baseURI = 'nominas/vacaciones-empleados-importar-excel';

export const vacacionesRegistrosPermission = {
  permissionModel: 'vacacionempleadodiadisfrutado',
  catalogsModels: [],
  tabsModels: [],
};

// eslint-disable-next-line react/prop-types
const VacacionesRegistros = ({ permission }) => {
  const user = useSelector(selectUser);
  const [loading, setLoading] = useState(false);
  const [calculando, setCalculando] = useState(false);
  const [open, setVisible] = useState(false);
  const [estadosDelEmpleado, setEstadosDelEmpleado] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [vacacionesEmpleadosPeriodos, setVacacionesEmpleadosPeriodos] = useState([]);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isPollingImport, setIsPollingImport] = useState(false);
  const [progresoImport, setProgresoImport] = useState({ en_curso: 0, total: 0 });
  const pollingImportRef = useRef(null);
  const [isPollingActualizar, setIsPollingActualizar] = useState(false);
  const [progresoActualizar, setProgresoActualizar] = useState({ en_curso: 0, total: 0 });
  const pollingActualizarRef = useRef(null);
  const [visibleConfirmarActualizar, setVisibleConfirmarActualizar] = useState(false);
  const [form] = Form.useForm();
  const [formEncabezado] = Form.useForm();
  const [formCarga] = Form.useForm();

  // Tabs de autorización (Autorizar / Autorizados / Cancelados)
  // La pantalla abre en "Todos" (primer tab).
  const [currentParentTabKey, setCurrentParentTabKey] = useState('todos');
  const [estados, setEstados] = useState([]);
  const [porAutorizar, setPorAutorizar] = useState([]);
  const [autorizados, setAutorizados] = useState([]);
  const [cancelados, setCancelados] = useState([]);
  // Tab "Todos": registros de Autorizar + Autorizados + Cancelados juntos.
  const [todosRegistros, setTodosRegistros] = useState([]);
  const [selectedRowKeysAutorizacion, setSelectedRowKeysAutorizacion] = useState([]);
  const [currentTableData, setCurrentTableData] = useState([]);
  const [loadingAutorizacion, setLoadingAutorizacion] = useState(false);

  // Filtros en cascada Año de Vacaciones / Periodo Vacacional para los tabs
  // Autorizar/Autorizados/Cancelados — mismo patrón que Registro de Guardias
  // (RegistroGuardiasMenu.jsx: filtrosCascada/applyFilters).
  const [aniosGuardias, setAniosGuardias] = useState([]);
  const [periodosGuardiasFiltro, setPeriodosGuardiasFiltro] = useState([]);
  const [filtroAnio, setFiltroAnio] = useState(null);
  const [filtroPeriodo, setFiltroPeriodo] = useState(null);
  const [loadingPeriodosFiltro, setLoadingPeriodosFiltro] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editSelectedEmpleado, setEditSelectedEmpleado] = useState(null);
  const [editRecordId, setEditRecordId] = useState(null);
  const [visibleConfirmAutorizarMasivo, setVisibleConfirmAutorizarMasivo] = useState(false);
  const [visibleConfirmCancelarMasivo, setVisibleConfirmCancelarMasivo] = useState(false);
  const [visibleConfirmReactivarMasivo, setVisibleConfirmReactivarMasivo] = useState(false);

  // Reporte de Guardias (mismo reporte/modal que Registro de Guardias)
  const [configurarGuardias, setConfigurarGuardias] = useState([]);
  const [showSelectionModal, setShowSelectionModal] = useState(false);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [loadingPdfModal, setLoadingPdfModal] = useState(false);
  const [pdfBase64, setPdfBase64] = useState('');
  const clienteAutorizar = CRUDgeneric('/nominas/autorizar-vacaciones-empleados-dias-disfrutados/');
  const clienteVacaciones = CRUDgeneric('/nominas/vacaciones-empleados-dias-disfrutados/');
  const [visibleEliminar, setVisibleEliminar] = useState(false);
  const [loadingEliminar, setLoadingEliminar] = useState(false);

  useEffect(() => {
    let mounted = true;
    Promise.all([
      getEstadosGlobales(),
      getGuardiasVacacionalesGeneral({ estados_globales: ESTATUS_AUTORIZADO }),
    ]).then(async ([_estados, _aniosGuardias]) => {
      if (!mounted) return;
      setEstados(_estados);
      setAniosGuardias(_aniosGuardias || []);
      const periodosPromises = (_aniosGuardias || []).map((g) => getGuardiasVacacionalesPeriodos({
        configurar_guardias_vacacionales_general: g.id,
      }).catch(() => []));
      const _allPeriodos = await Promise.all(periodosPromises);
      if (mounted) {
        setConfigurarGuardias(_allPeriodos.flat());
      }
    });
    return () => { mounted = false; };
  }, []);

  const onFiltroAnioChange = async (anioId) => {
    setFiltroAnio(anioId);
    setFiltroPeriodo(null);
    setPeriodosGuardiasFiltro([]);
    if (!anioId) return;
    setLoadingPeriodosFiltro(true);
    try {
      const resp = await getGuardiasVacacionalesPeriodos({
        estados_globales: ESTATUS_AUTORIZADO,
        configurar_guardias_vacacionales_general: anioId,
      });
      setPeriodosGuardiasFiltro(resp || []);
    } catch {
      setPeriodosGuardiasFiltro([]);
    } finally {
      setLoadingPeriodosFiltro(false);
    }
  };

  const fetchAutorizacionData = async () => {
    setLoadingAutorizacion(true);
    const _data = await obtenerRegistrosDe('/nominas/vacaciones-empleados-dias-disfrutados-vista-optimized/');
    setPorAutorizar(_data?.filter((registro) => registro?.estados_globales_id === ESTATUS_ACTIVO));
    setAutorizados(_data?.filter((registro) => registro?.estados_globales_id === ESTATUS_AUTORIZADO));
    setCancelados(_data?.filter((registro) => registro?.estados_globales_id === ESTATUS_CANCELADO));
    setTodosRegistros(_data?.filter((registro) => [ESTATUS_ACTIVO, ESTATUS_AUTORIZADO, ESTATUS_CANCELADO]
      .includes(registro?.estados_globales_id)) || []);
    setSelectedRowKeysAutorizacion([]);
    setCurrentTableData([]);
    setLoadingAutorizacion(false);
  };

  // "Todos" es el tab inicial: sus registros se cargan al montar (antes solo se
  // cargaban al cambiar a un tab de estatus).
  useEffect(() => {
    fetchAutorizacionData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = async (activeKey) => {
    setCurrentParentTabKey(activeKey);
    setSelectedRowKeysAutorizacion([]);
    setCurrentTableData([]);
    if (activeKey !== 'registro') {
      await fetchAutorizacionData();
    }
  };

  const handleAutorizacionTableChange = (_pagination, _filters, _sorter, extra) => {
    if (extra?.currentDataSource) {
      setCurrentTableData(extra.currentDataSource);
    }
  };

  const applyAutorizacionFilters = (registros) => {
    if (!filtroAnio && !filtroPeriodo) return [];
    let filtered = registros;
    if (filtroAnio) {
      const anio = aniosGuardias.find((a) => a.id === filtroAnio);
      if (anio) {
        const anioStr = String(anio.periodo_fiscal?.periodo ?? anio.periodo_fiscal ?? '');
        filtered = filtered.filter((r) => String(r.periodo_fiscal) === anioStr);
      }
    }
    if (filtroPeriodo) {
      const periodo = periodosGuardiasFiltro.find((p) => p.id === filtroPeriodo);
      if (periodo) {
        const periodoStr = String(periodo.periodos_vacacionales?.periodo ?? periodo.periodo ?? '');
        filtered = filtered.filter((r) => String(r.periodos_vacacionales_periodo) === periodoStr);
      }
    }
    return filtered;
  };

  const getRegistrosPorTab = () => {
    if (currentParentTabKey === 'todos') return todosRegistros;
    if (currentParentTabKey === 'autorizar') return porAutorizar;
    if (currentParentTabKey === 'autorizados') return autorizados;
    return cancelados;
  };

  const effectiveAutorizacionData = currentTableData.length
    ? currentTableData
    : applyAutorizacionFilters(getRegistrosPorTab());

  const rowSelectionAutorizacion = {
    selectedRowKeys: selectedRowKeysAutorizacion,
    type: 'checkbox',
    columnTitle: (
      <Checkbox
        checked={selectedRowKeysAutorizacion.length > 0
          && selectedRowKeysAutorizacion.length === effectiveAutorizacionData.length}
        indeterminate={selectedRowKeysAutorizacion.length > 0
          && selectedRowKeysAutorizacion.length < effectiveAutorizacionData.length}
        onChange={(e) => {
          // flushSync: fuerza a React a aplicar el cambio de selección (y por
          // tanto recalcular el `disabled` de Editar/Autorizar/Cancelar/Reactivar)
          // de forma síncrona, antes de que el navegador procese el siguiente
          // clic del usuario. Sin esto, un clic muy rápido en Editar justo
          // después de seleccionar puede caer en un botón que el DOM aún no
          // terminó de habilitar (carrera de renderizado).
          flushSync(() => {
            if (e.target.checked) {
              setSelectedRowKeysAutorizacion(effectiveAutorizacionData.map((row) => row.id));
            } else {
              setSelectedRowKeysAutorizacion([]);
            }
          });
        }}
      />
    ),
    onSelect: (record, selected) => {
      flushSync(() => {
        if (selected) {
          setSelectedRowKeysAutorizacion((prev) => [...prev, record.id]);
        } else {
          setSelectedRowKeysAutorizacion((prev) => prev.filter((key) => key !== record.id));
        }
      });
    },
    onChange: (keys) => {
      flushSync(() => {
        setSelectedRowKeysAutorizacion(keys);
      });
    },
  };

  // El checkbox de selección tiene pointer-events: none por CSS global
  // (src/components/Layout/index.scss), igual que en Nombramientos — por eso
  // la selección/deselección se hace también al hacer clic en cualquier parte de la fila.
  // Se usa flushSync (ver nota arriba) para que el botón Editar quede habilitado
  // de inmediato, sin depender de que el siguiente clic llegue después de que
  // React termine de re-renderizar por su cuenta.
  const handleOnRowClickAutorizacion = (record) => {
    flushSync(() => {
      setSelectedRowKeysAutorizacion((prev) => (
        prev.includes(record.id)
          ? prev.filter((key) => key !== record.id)
          : [...prev, record.id]
      ));
    });
  };

  const autorizarOCancelarMasivo = async (estadoDestino) => {
    try {
      setLoadingAutorizacion(true);
      const ids = selectedRowKeysAutorizacion.map((id) => ({ id }));
      const saved = await clienteAutorizar.reemplazarRegistro(estadoDestino, ids);
      if (saved) {
        setVisibleConfirmAutorizarMasivo(false);
        setVisibleConfirmCancelarMasivo(false);
        setVisibleConfirmReactivarMasivo(false);
        await fetchAutorizacionData();
      }
      setLoadingAutorizacion(false);
    } catch (err) {
      onError(err, setLoadingAutorizacion);
    }
  };

  const onClickEditFromTab = () => {
    if (selectedRowKeysAutorizacion.length !== 1) return;
    const [registroId] = selectedRowKeysAutorizacion;
    const registro = [...porAutorizar, ...autorizados, ...cancelados].find((r) => r.id === registroId);
    if (!registro) return;
    setEditSelectedEmpleado(registro.empleado_id ?? registro.empleado);
    setEditRecordId(registroId);
    setEditModalOpen(true);
  };

  const onCloseEditModal = async () => {
    setEditModalOpen(false);
    setEditSelectedEmpleado(null);
    setEditRecordId(null);
    setSelectedRowKeysAutorizacion([]);
    await fetchAutorizacionData();
  };

  const onConfirmAutorizarMasivo = () => setVisibleConfirmAutorizarMasivo(true);

  const onConfirmCancelarMasivo = () => setVisibleConfirmCancelarMasivo(true);

  const onConfirmReactivarMasivo = () => setVisibleConfirmReactivarMasivo(true);

  const onClickVerReporte = () => {
    setSelectedPeriodo(null);
    setShowSelectionModal(true);
  };

  const onConfirmSelectionModal = async () => {
    if (!selectedPeriodo) {
      notification.warning({ message: 'Selecciona un periodo vacacional.' });
      return;
    }
    setShowSelectionModal(false);
    setLoadingPdfModal(true);
    setShowPdfModal(true);

    const values = {
      ID: 10002,
      Parametros: [
        {
          Nombre: 'configurar_guardias_vacacionales',
          TipoParametro: 'numero',
          Valor: String(selectedPeriodo),
        },
        {
          Nombre: 'usuario',
          TipoParametro: 'id',
          Valor: String(user?.id),
        },
      ],
    };

    try {
      const fileBase64 = await postObtenerReporte(values);
      if (fileBase64) {
        setPdfBase64(fileBase64);
      } else {
        // Se mantiene el modal abierto mostrando el estado vacío en lugar de cerrarlo,
        // para que el usuario siempre vea abrirse el modal de vista previa del reporte.
        setPdfBase64('');
        notification.error({ message: 'Error al generar el reporte.' });
      }
    } catch (error) {
      setPdfBase64('');
      notification.error({ message: 'Error al cargar el reporte.' });
    } finally {
      setLoadingPdfModal(false);
    }
  };

  const onClosePdfModal = () => {
    setShowPdfModal(false);
    setPdfBase64('');
  };

  const columnasAutorizacion = [
    {
      titleText: 'Id',
      dataIndex: 'id',
      key: 'id',
      width: 100,
    },
    {
      titleText: 'Año',
      dataIndex: 'ano',
      key: 'ano',
      width: 100,
    },
    {
      titleText: 'Periodo',
      dataIndex: 'periodo_texto',
      key: 'periodo_texto',
      width: 200,
    },
    {
      titleText: 'Empleado',
      dataIndex: 'numero_y_nombre_completo',
      key: 'numero_y_nombre_completo',
      width: 250,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_de_area_clave_y_nombre',
      key: 'directorio_de_area_clave_y_nombre',
      width: 150,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 190,
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_inicial',
      key: 'fecha_inicial',
      width: 150,
      // En dd/mm/aaaa (el API la manda en ISO), igual que las demás fechas del sistema,
      // para que la Búsqueda por fecha coincida con lo que se ve.
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_final',
      key: 'fecha_final',
      width: 150,
      // En dd/mm/aaaa (el API la manda en ISO), igual que las demás fechas del sistema,
      // para que la Búsqueda por fecha coincida con lo que se ve.
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Días Hábiles Disfrutados',
      dataIndex: 'dias_habiles_disfrutados',
      key: 'dias_habiles_disfrutados',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales_id',
      key: 'estados_globales_id',
      width: 150,
      // Tag con color por estatus (mismo criterio que Registro de Incidencias). El
      // children es el texto, así que filtro y orden siguen funcionando igual.
      render: (val) => {
        const descripcion = estados.find((e) => e.id === val)?.descripcion;
        if (!descripcion) return null;
        let color = 'blue';
        if (val === ESTATUS_AUTORIZADO) color = 'green';
        if (val === ESTATUS_CANCELADO) color = 'red';
        return <Tag color={color}>{descripcion}</Tag>;
      },
    },
  ];

  // Un empleado es "vigente" para Registro de Vacaciones si tiene una plaza
  // asignada actualmente y no es Jubilado/Pensionado. empleados-vista-optimized
  // ya trae plaza/puesto/área/tipo de nómina/antigüedad/días en un solo rengón
  // por empleado, evitando traer y cruzar en el navegador las tablas completas
  // de empleados, datos operacionales, plazas y administraciones de plaza.
  const filtrarEmpleadosVigentes = (emps) => emps.filter((emp) => (
    emp?.plaza_id != null
    && emp?.tipo_de_funcion_id !== TIPO_DE_FUNCION_JUBILADO
    && emp?.tipo_de_funcion_id !== TIPO_DE_FUNCION_PENSIONADO
  ));

  const fetchData = async () => {
    setLoading(true);
    const [_empleados, _vacacionesEmpleadosPeriodos] = await Promise.all([
      getEmpleadosvistaOptimized(),
      getVacacionesEmpleadosPeriodos(),
    ]);
    const empsFiltered = filtrarEmpleadosVigentes(_empleados);
    setVacacionesEmpleadosPeriodos(_vacacionesEmpleadosPeriodos);
    setData(empsFiltered);
    setLoading(false);
    // Se devuelven los datos frescos porque los estados de React no se
    // reflejan dentro de la misma invocación (closure).
    return {
      empleados: empsFiltered,
      periodos: _vacacionesEmpleadosPeriodos,
    };
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tipos_nominas_empleados,
        _empleados,
        _procesoActualizarAntiguedad,
        _vacacionesEmpleadosPeriodos,
        _estadosDelEmpleado,
      ] = await Promise.all([
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getEmpleadosvistaOptimized(),
        getProcesoEnCursoTerminado({ descripcion: DESCRIPCION_PROCESO_ACTUALIZAR_ANTIGUEDAD }),
        getVacacionesEmpleadosPeriodos(),
        getEstadosDeEmpleados(),
      ]);
      const procesoActualizarAntiguedad = _procesoActualizarAntiguedad?.[0];
      if (mounted) {
        setEstadosDelEmpleado(_estadosDelEmpleado);
        setTiposNominasEmpleados(_tipos_nominas_empleados);
        setVacacionesEmpleadosPeriodos(_vacacionesEmpleadosPeriodos);
        setEmpleados(_empleados);
        if (procesoActualizarAntiguedad?.procesando) {
          setCalculando(true);
          setProgresoActualizar({
            en_curso: procesoActualizarAntiguedad?.registro_en_curso || 0,
            total: procesoActualizarAntiguedad?.total_registros || 0,
          });
          setIsPollingActualizar(true);
        } else {
          setCalculando(false);
        }
        setData(filtrarEmpleadosVigentes(_empleados));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  // UseEffect para el manejo de la conexion por sockets
  // useEffect(() => {
  //   let chatSocket;
  //   if (renderizado) {
  //     chatSocket = new WebSocket(`ws://${API_HOST}/ws/antiguedad/${PROCESO_ASINCRONO_ANTIGUEDAD}/`);
  //     setTimeout(() => {
  //       if (chatSocket.readyState === 1) {
  //         chatSocket.send(JSON.stringify({
  //           type: 'message',
  //           message: PROCESO_ASINCRONO_ANTIGUEDAD,
  //           name: PROCESO_ASINCRONO_ANTIGUEDAD,
  //         }));
  //       }
  //     }, 500);
  //     chatSocket.onmessage = (message) => {
  //       const dataFromserver = JSON.parse(message.data);
  //       if (dataFromserver.message) {
  //         setCalculando(false);
  //         setRenderizado(false);
  //         fetchData();
  //       }
  //     };
  //   }
  //   return () => {
  //     if (chatSocket) {
  //       chatSocket.close();
  //     }
  //   };
  // });

  const onCancel = () => {
    setSelectedRowKeys([]);
    setCalculando(false);
    setVisible(false);
    setVisibleModal(false);
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    try {
      setLoading(true);
      formEncabezado.resetFields();

      const [key] = selectedRowKeys;
      if (!key && !responseData) return; // Evitar ejecución si no hay registro seleccionado

      const fresh = await fetchData();
      const targetId = responseData?.id || key;
      const _empleado = (fresh?.empleados?.length ? fresh.empleados : data)?.find((item) => item.id === targetId);

      if (!_empleado) return;

      const _periodosEmpleado = (fresh?.periodos || vacacionesEmpleadosPeriodos)?.filter((periodo) => periodo?.empleado === _empleado?.id) || [];
      const diasConDerecho = _periodosEmpleado.reduce((acc, periodo) => acc + (periodo?.total_de_dias_habiles_por_ano || 0), 0);

      form.resetFields();
      form.setFieldsValue({
        empleado: _empleado?.numero_y_nombre_completo,
        plaza: _empleado?.plaza_clave_y_descripcion,
        puesto: _empleado?.puesto_clave_y_descripcion,
        unidad_responsable: _empleado?.directorio_area_clave_y_nombre,
        tipo_nomina_empleado: _empleado?.tipo_nomina_empleado,
        fecha_alta: _empleado?.fecha_de_alta,
        antiguedad: _empleado?.antiguedad_texto,
        dias_habiles_derecho: diasConDerecho,
        dias_habiles_disfrutados: _empleado?.dias_habiles_disfrutados,
        dias_habiles_pendientes: _empleado?.dias_habiles_pendientes,
        estado_del_empleado: _empleado?.estado_del_empleado_id,
      });

      setVisible(true); // Abrir la vista general del empleado
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false); // Siempre quitar la pantalla de carga al terminar
    }
  };

  const onClickReload = () => {
    setVisibleConfirmarActualizar(true);
  };

  const onConfirmActualizarAntiguedad = async () => {
    setVisibleConfirmarActualizar(false);
    formEncabezado.resetFields();
    form.resetFields();
    setCalculando(true);
    setProgresoActualizar({ en_curso: 0, total: 0 });
    await postActualizarAntiguedad();
    setIsPollingActualizar(true);
    setLoading(false);
  };

  // ── Polling via ProcesoEnCursoTerminado (patrón Histórico Sindicato / SBC) ──
  // Consulta cada 2s, actualiza progresoImport y detecta fin de tarea (procesando === false).
  useEffect(() => {
    if (!isPollingImport) return () => {};

    let intentos = 0;
    const maxIntentos = 340; // máx ~11 min

    pollingImportRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_IMPORTAR_VACACIONES,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoImport({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingImportRef.current);
          pollingImportRef.current = null;
          setIsPollingImport(false);
          setProgresoImport({ en_curso: 0, total: 0 });

          if (proceso?.resultado) {
            const byteCharacters = atob(proceso.resultado);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i += 1) {
              byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Vacaciones_Resultado.xlsx';
            link.click();
            URL.revokeObjectURL(url);
          }

          notification.success({
            message: 'Importación completada',
            description: 'La carga masiva de Registro de Vacaciones finalizó. Se descargó el archivo de resultado con el estatus de cada renglón.',
            placement: 'topRight',
            duration: 6,
          });
          await fetchData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling importación registro de vacaciones] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingImportRef.current) {
        clearInterval(pollingImportRef.current);
        pollingImportRef.current = null;
      }
    };
  }, [isPollingImport]);

  // ── Polling via ProcesoEnCursoTerminado para la Actualización de Antigüedad ──
  // Consulta cada 2s, actualiza progresoActualizar y detecta fin de tarea (procesando === false).
  useEffect(() => {
    if (!isPollingActualizar) return () => {};

    let intentos = 0;
    const maxIntentos = 340; // máx ~11 min

    pollingActualizarRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: DESCRIPCION_PROCESO_ACTUALIZAR_ANTIGUEDAD,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoActualizar({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingActualizarRef.current);
          pollingActualizarRef.current = null;
          setIsPollingActualizar(false);
          setCalculando(false);
          setProgresoActualizar({ en_curso: 0, total: 0 });

          notification.success({
            message: 'Actualización completada',
            description: proceso?.mensaje || 'La actualización de antigüedad y vacaciones de los empleados finalizó.',
            placement: 'topRight',
            duration: 6,
          });
          await fetchData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling actualización de antigüedad] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingActualizarRef.current) {
        clearInterval(pollingActualizarRef.current);
        pollingActualizarRef.current = null;
      }
    };
  }, [isPollingActualizar]);

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
        const response = await HTTP.post(`${baseURL}${uri}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (response?.status === 202) {
          setVisibleModal(false);
          formCarga.resetFields();
          setProgresoImport({ en_curso: 0, total: 0 });
          setIsPollingImport(true);
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickObtenerPlantilla = async () => {
    try {
      setLoading(true);
      const excel = await getVacacionesPlantillaExcel();
      if (excel) {
        const blob = new Blob([excel], {
          type: 'application/ms-excel',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Vacaciones_Plantilla.xlsx';
        link.click();
      }
      setLoading(false);
    } catch (err) {
      onError(err);
    }
  };

  const onClickCargar = () => {
    setVisibleModal(true);
  };

  const menuImport = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Obtener Plantilla',
          text: 'Obtener Plantilla',
          icon: <FileExcelOutlined />,
          onClick: () => onClickObtenerPlantilla(),
        },
        {
          key: 2,
          label: 'Cargar',
          text: 'Cargar',
          icon: <DownloadOutlined />,
          onClick: () => onClickCargar(),
        },
      ]}
    />
  );

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'No. y Nombre de Empleado',
      dataIndex: 'numero_y_nombre_completo',
      key: 'numero_y_nombre_completo',
      width: 300,
    },
    {
      titleText: 'Plaza',
      dataIndex: 'plaza_clave_y_descripcion',
      key: 'plaza_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_clave_y_descripcion',
      key: 'puesto_clave_y_descripcion',
      width: 200,
    },
    {
      titleText: 'Área',
      dataIndex: 'directorio_area_clave_y_nombre',
      key: 'directorio_area_clave_y_nombre',
      width: 200,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_nomina_empleado',
      key: 'tipo_nomina_empleado',
      width: 220,
    },
    {
      titleText: 'Fecha de Alta',
      dataIndex: 'fecha_de_alta',
      key: 'fecha_de_alta',
      width: 150,
      // En dd/mm/aaaa (el API la manda en ISO), igual que las demás fechas del sistema,
      // para que la Búsqueda por fecha coincida con lo que se ve.
      render: (val) => (val ? moment(val).format('DD/MM/YYYY') : ''),
    },
    {
      titleText: 'Antigüedad',
      dataIndex: 'antiguedad_texto',
      key: 'antiguedad_texto',
      width: 150,
    },
    {
      titleText: 'Días Hábiles con Derecho',
      dataIndex: 'id',
      key: 'dias_habiles_derecho_emp',
      width: 180,
      render: (idEmp) => vacacionesEmpleadosPeriodos
        .filter((periodo) => periodo?.empleado === idEmp)
        .reduce((acc, periodo) => acc + (periodo?.total_de_dias_habiles_por_ano || 0), 0),
    },
    {
      titleText: 'Días Hábiles Disfrutados',
      dataIndex: 'dias_habiles_disfrutados',
      key: 'dias_habiles_disfrutados',
      width: 180,
    },
    {
      titleText: 'Días Hábiles Pendientes',
      dataIndex: 'dias_habiles_pendientes',
      key: 'dias_habiles_pendientes',
      width: 180,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_del_empleado',
      key: 'estado_del_empleado',
      width: 150,
      render: (val) => val?.toUpperCase(),
    },
  ];

  // Eliminar (tab "Todos"): borrado lógico de un registro Activo; el backend recalcula los
  // días disfrutados del empleado y rechaza estatus que no permiten eliminar.
  const eliminarVacacion = async () => {
    const [id] = selectedRowKeysAutorizacion;
    if (!id) return;
    setLoadingEliminar(true);
    const eliminado = await clienteVacaciones.borrarRegistro(id);
    setLoadingEliminar(false);
    if (eliminado) {
      setVisibleEliminar(false);
      await fetchAutorizacionData();
    }
  };

  const renderAutorizacionTab = (registros, tabKey) => {
    const filteredData = applyAutorizacionFilters(registros);
    const enTodos = tabKey === 'todos';
    // true si hay selección y TODOS los registros seleccionados están en alguno de
    // los estatus permitidos. En los tabs por estatus todas las filas comparten
    // estatus; en "Todos" esto decide qué acción aplica.
    const seleccionados = registros.filter((r) => selectedRowKeysAutorizacion.includes(r.id));
    const seleccionEnEstados = (estadosPermitidos) => seleccionados.length > 0
      && seleccionados.every((r) => estadosPermitidos.includes(r.estados_globales_id));

    // En "Todos", Editar va en la barra (junto a Agregar/Eliminar), no en el menú.
    const customActions = enTodos ? [] : [
      {
        onClick: onClickEditFromTab,
        text: 'Editar',
        icon: <EditOutlined />,
        disabledBySelection: true,
        disabled: selectedRowKeysAutorizacion?.length !== 1,
      },
    ];

    if (tabKey === 'autorizar' || enTodos) {
      customActions.push({
        onClick: onConfirmAutorizarMasivo,
        text: 'Autorizar',
        icon: <CheckCircleOutlined />,
        disabledBySelection: true,
        disabled: !seleccionEnEstados([ESTATUS_ACTIVO]),
        className: 'success',
      });
    }

    if (tabKey === 'autorizar' || tabKey === 'autorizados' || enTodos) {
      customActions.push({
        onClick: onConfirmCancelarMasivo,
        text: 'Cancelar',
        icon: <CheckCircleOutlined />,
        disabledBySelection: true,
        disabled: !seleccionEnEstados([ESTATUS_ACTIVO, ESTATUS_AUTORIZADO]),
        className: 'cancel',
      });
    }

    if (tabKey === 'autorizados' || tabKey === 'cancelados' || enTodos) {
      customActions.push({
        onClick: onConfirmReactivarMasivo,
        permission: { model: 'vacacionempleadodiadisfrutado', action: 'reactivar' },
        text: 'Reactivar',
        icon: <CheckCircleOutlined />,
        disabledBySelection: true,
        disabled: !seleccionEnEstados([ESTATUS_AUTORIZADO, ESTATUS_CANCELADO]),
        className: 'success',
      });
    }

    if (tabKey === 'autorizados' || enTodos) {
      customActions.push({
        onClick: onClickVerReporte,
        text: 'Ver Reporte',
        icon: <EyeOutlined />,
        disabledBySelection: false,
      });
    }

    return (
      <Spin tip="Cargando..." spinning={loadingAutorizacion}>
        <Form layout="vertical">
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Form.Item label="Año de Vacaciones" hasFeedback>
                <AntdSelect
                  allowClear
                  placeholder="Selecciona un año"
                  value={filtroAnio}
                  onChange={onFiltroAnioChange}
                  options={(aniosGuardias || []).map((a) => ({
                    value: a.id,
                    label: String(a.periodo_fiscal?.periodo ?? a.periodo_fiscal ?? a.id),
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item label="Periodo Vacacional" hasFeedback>
                <AntdSelect
                  allowClear
                  placeholder={filtroAnio ? 'Selecciona un periodo' : 'Primero selecciona un año'}
                  disabled={!filtroAnio}
                  loading={loadingPeriodosFiltro}
                  value={filtroPeriodo}
                  onChange={setFiltroPeriodo}
                  options={(periodosGuardiasFiltro || []).map((p) => ({
                    value: p.id,
                    label: p.periodos_vacacionales?.periodo ?? p.periodo ?? String(p.id),
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Table
          data={filteredData}
          cols={columnasAutorizacion}
          allowExportParam={false}
          rowSelection={rowSelectionAutorizacion}
          handleOnRowClick={handleOnRowClickAutorizacion}
          onTableChange={handleAutorizacionTableChange}
          customActions={customActions}
          customActionsDropdown
          customActionsDropdownText="Acciones"
          // "Todos": Agregar lleva al tab Registro (donde se captura); Editar abre el
          // modal de edición; Eliminar solo aplica a un registro Activo.
          controls={enTodos ? {
            onClickAdd: () => handleTabChange('registro'),
            onClickEdit: onClickEditFromTab,
            onClickDelete: () => setVisibleEliminar(true),
          } : undefined}
          disableDelete={enTodos && (selectedRowKeysAutorizacion.length !== 1
            || !seleccionEnEstados([ESTATUS_ACTIVO]))}
          permission={permission}
        />
      </Spin>
    );
  };

  return (
    <Row className="container">
      <Card className="form-container" bordered={false}>
        <Tabs type="card" activeKey={currentParentTabKey} onChange={handleTabChange}>
          <TabPane tab="Todos" key="todos" forceRender>
            {renderAutorizacionTab(todosRegistros, 'todos')}
          </TabPane>
          <TabPane tab="Registro" key="registro" forceRender>
            <Spin
              tip={
                progresoActualizar.total > 0
                  ? `Actualizando Antigüedad y Vacaciones... ${progresoActualizar.en_curso} / ${progresoActualizar.total} (${Math.round((progresoActualizar.en_curso / progresoActualizar.total) * 100)}%)`
                  : 'Actualizando Antigüedad y Vacaciones...'
              }
              spinning={calculando}
            >
              <Spin tip="Cargando..." spinning={loading}>
                {!open ? (
                  <Form
                    layout="vertical"
                    form={formEncabezado}
                    scrollToFirstError
                    name="general"
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="numero_empleado"
                          label="No. y Nombre de Empleado"
                          hasFeedback
                        >
                          <Select
                            dataSource={empleados}
                            render={(emp) => {
                              if (emp?.apellido_materno) {
                                return `${emp?.numero_de_empleado} - ${emp?.nombre} ${emp?.apellido_paterno} ${emp?.apellido_materno}`;
                              }
                              return `${emp?.numero_de_empleado} - ${emp?.nombre} ${emp?.apellido_paterno}`;
                            }}
                            onChange={(val) => {
                              const tipoNomina = formEncabezado.getFieldValue('tipo_nomina_empleado');
                              let empleadosFiltrados = tipoNomina
                                ? empleados.filter((emp) => emp?.tipo_nomina_empleado_id === tipoNomina)
                                : empleados;
                              if (val) {
                                empleadosFiltrados = empleadosFiltrados.filter((emp) => emp?.id === val);
                                setData(empleadosFiltrados);
                                return;
                              }
                              setData(tipoNomina ? empleadosFiltrados : filtrarEmpleadosVigentes(empleadosFiltrados));
                            }}
                            allowClear
                            disabled={formEncabezado.getFieldValue('tipo_nomina_empleado')}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tipo_nomina_empleado"
                          label="Tipo de Nómina Empleado"
                          hasFeedback
                        >
                          <Select
                            dataSource={tiposNominasEmpleados}
                            onChange={(val) => {
                              const empleadoId = formEncabezado.getFieldValue('numero_empleado');
                              let empleadosFiltrados = val
                                ? empleados.filter((emp) => emp?.tipo_nomina_empleado_id === val)
                                : empleados;
                              if (empleadoId) {
                                empleadosFiltrados = empleadosFiltrados.filter((emp) => emp?.id === empleadoId);
                              }
                              setData(empleadosFiltrados);
                            }}
                            allowClear
                            disabled={formEncabezado.getFieldValue('numero_empleado')}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Table
                      data={data}
                      cols={columns}
                      allowExportParam={false}
                      rowSelection={rowSelection}
                      handleOnRowClick={handleOnRowClick}
                      controls={{
                        onClickEdit: () => onClickEdit(),
                        onClickReload: () => onClickReload(),
                      }}
                      allowCustomImport
                      customImportMenu={menuImport}
                      customImportText="Importar Vacaciones"
                      allowSearch={false}
                      allowReload
                      permission={permission}
                      fillHeight
                    />
                  </Form>
                ) : (
                  <Card
                    className="form-container"
                    title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Registro de Vacaciones`}
                    extra={(
                      <FormSubmitControls
                        onCancel={onCancel}
                        loading={loading}
                      />
              )}
                    bordered={false}
                  >
                    <Form
                      layout="vertical"
                      form={form}
                      scrollToFirstError
                      name="general"
                    >
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="empleado"
                            label="No. y Nombre de Empleado"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="plaza"
                            label="Plaza"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="puesto"
                            label="Puesto"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="unidad_responsable"
                            label="Área"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="tipo_nomina_empleado"
                            label="Tipo de Nómina Empleado"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="fecha_alta"
                            label="Fecha de Alta"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="antiguedad"
                            label="Antigüedad"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="dias_habiles_derecho"
                            label="Días con Derecho"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="dias_habiles_disfrutados"
                            label="Días Disfrutados"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="dias_habiles_pendientes"
                            label="Días Pendientes"
                            hasFeedback
                          >
                            <Input
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="estado_del_empleado"
                            label="Estatus del Empleado"
                            hasFeedback
                          >
                            <Select
                              dataSource={estadosDelEmpleado}
                              disabled
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Form.Item hidden>
                        <Button htmlType="submit" />
                      </Form.Item>
                    </Form>
                    {selectedRowKeys.length ? (
                      <VacacionesRegistrosEmpleados
                        permission={permission}
                        selectedEmpleado={selectedRowKeys}
                      />
                    ) : null}
                  </Card>
                )}
                <Modal
                  open={visibleModal}
                  title={(
                    <FormSubmitControls
                      label="Carga Masiva"
                      onFinish={onUpload}
                      onCancel={onCancel}
                      loading={loading}
                    />
            )}
                  onCancel={onCancel}
                  footer={null}
                  closable={false}
                  maskClosable={!loading}
                  keyboard={!loading}
                  forceRender
                  destroyOnClose
                >
                  <Spin tip="Cargando..." spinning={loading}>
                    <Form
                      layout="vertical"
                      form={formCarga}
                      name="carga"
                      onFinish={onUpload}
                    >
                      <Dragger
                        label="Archivo"
                        limitMB={30}
                        rules={rules.required}
                        name="file"
                        allowedExtensions={['xlsx']}
                      />
                    </Form>
                  </Spin>
                </Modal>

                {/* Modal Confirmación Actualizar Antigüedad y Vacaciones */}
                <ModalConfirmation
                  onFinish={onConfirmActualizarAntiguedad}
                  onFinishText="Actualizar"
                  onCancel={() => setVisibleConfirmarActualizar(false)}
                  contentTitle="Actualizar la Antigüedad y Vacaciones de los Empleados"
                  open={visibleConfirmarActualizar}
                  loading={calculando}
                  extraContent={(
                    <p style={{ marginTop: 8 }}>
                      Se ejecutará un barrido manual de los empleados del sistema para verificar
                      quiénes ya son aptos para generar o disfrutar vacaciones, actualizando su
                      antigüedad y sus periodos vacacionales. Este proceso puede tardar varios
                      minutos dependiendo del número de empleados.
                    </p>
                  )}
                />

                {/* Modal Progreso Importación */}
                <Modal
                  open={isPollingImport}
                  title="Importando Registro de Vacaciones..."
                  footer={null}
                  closable={false}
                  maskClosable={false}
                  centered
                >
                  <div style={{ textAlign: 'center', padding: '16px 0' }}>
                    <Progress
                      type="circle"
                      percent={
                      progresoImport.total > 0
                        ? Math.round((progresoImport.en_curso / progresoImport.total) * 100)
                        : 0
                    }
                    />
                    <p style={{ marginTop: 16 }}>
                      {progresoImport.en_curso}
                      {' / '}
                      {progresoImport.total}
                      {' registros procesados'}
                    </p>
                  </div>
                </Modal>
              </Spin>
            </Spin>
          </TabPane>
          <TabPane tab="Autorizar" key="autorizar" forceRender>
            {renderAutorizacionTab(porAutorizar, 'autorizar')}
          </TabPane>
          <TabPane tab="Autorizados" key="autorizados" forceRender>
            {renderAutorizacionTab(autorizados, 'autorizados')}
          </TabPane>
          <TabPane tab="Cancelados" key="cancelados" forceRender>
            {renderAutorizacionTab(cancelados, 'cancelados')}
          </TabPane>
        </Tabs>
      </Card>
      {editModalOpen && editSelectedEmpleado && (
        <VacacionesRegistrosEmpleados2
          permission={permission}
          selectedEmpleado={[editSelectedEmpleado]}
          autoEditRecordId={editRecordId}
          hideTables
          onHideTableClose={onCloseEditModal}
        />
      )}
      <ModalConfirmation
        open={visibleConfirmAutorizarMasivo}
        onFinish={() => autorizarOCancelarMasivo(ESTATUS_AUTORIZADO)}
        onCancel={() => setVisibleConfirmAutorizarMasivo(false)}
        loading={loadingAutorizacion}
        ConfirmAutorize
        contentTitle={`Autorizar los ${selectedRowKeysAutorizacion.length} registro(s) de vacaciones seleccionados`}
      />
      <ModalConfirmation
        open={visibleConfirmCancelarMasivo}
        onFinish={() => autorizarOCancelarMasivo(ESTATUS_CANCELADO)}
        onCancel={() => setVisibleConfirmCancelarMasivo(false)}
        loading={loadingAutorizacion}
        ConfirmCancel
        contentTitle={`Cancelar los ${selectedRowKeysAutorizacion.length} registro(s) de vacaciones seleccionados`}
      />
      <ModalConfirmation
        open={visibleConfirmReactivarMasivo}
        onFinish={() => autorizarOCancelarMasivo(ESTATUS_ACTIVO)}
        onCancel={() => setVisibleConfirmReactivarMasivo(false)}
        loading={loadingAutorizacion}
        ConfirmAutorize
        contentTitle={`Reactivar los ${selectedRowKeysAutorizacion.length} registro(s) de vacaciones seleccionados`}
      />
      <Modal
        open={showPdfModal}
        onCancel={onClosePdfModal}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        bodyStyle={{
          padding: 0,
          height: '80vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Spin spinning={loadingPdfModal} tip="Cargando reporte...">
          <div style={{
            backgroundColor: '#fff',
            padding: '20px 24px',
            borderBottom: '1px solid #f0f0f0',
          }}
          >
            <Row justify="space-between" align="middle">
              <Typography.Text strong style={{ fontSize: '18px' }}>
                Reporte de Guardias
              </Typography.Text>
            </Row>
          </div>
          <div style={{
            flex: 1,
            padding: '20px',
            backgroundColor: '#f5f5f5',
            overflow: 'auto',
          }}
          >
            {pdfBase64 ? (
              <iframe
                src={pdfBase64}
                style={{
                  width: '100%',
                  height: '100%',
                  border: '1px solid #d9d9d9',
                  borderRadius: '4px',
                  backgroundColor: 'white',
                }}
                title="Vista previa del reporte"
              />
            ) : (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                color: '#999',
              }}
              >
                <Empty description="No hay reporte para mostrar" />
              </div>
            )}
          </div>
          <div style={{
            padding: '16px 24px',
            borderTop: '1px solid #f0f0f0',
            backgroundColor: '#fff',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
          }}
          >
            <Button
              onClick={() => {
                if (pdfBase64) {
                  const downloadLink = document.createElement('a');
                  const fileName = `Reporte_Guardias_${new Date().getTime()}.pdf`;
                  downloadLink.href = pdfBase64;
                  downloadLink.download = fileName;
                  downloadLink.click();
                }
              }}
              disabled={!pdfBase64}
              icon={<DownloadOutlined />}
            >
              Descargar
            </Button>
            <Button
              type="primary"
              onClick={onClosePdfModal}
            >
              Cerrar
            </Button>
          </div>
        </Spin>
      </Modal>
      <Modal
        title="Configurar Reporte de Guardias"
        open={showSelectionModal}
        onCancel={() => {
          setShowSelectionModal(false);
          setSelectedPeriodo(null);
        }}
        onOk={onConfirmSelectionModal}
        okText="Generar Reporte"
        cancelText="Cancelar"
        destroyOnClose
      >
        <Form layout="vertical">
          <Form.Item label="Periodo Vacacional" required>
            <AntdSelect
              placeholder="Selecciona un periodo vacacional"
              value={selectedPeriodo}
              onChange={setSelectedPeriodo}
              options={(configurarGuardias || []).map((g) => ({
                value: g?.id,
                label: `${g?.configurar_guardias_vacacionales_general?.periodo_fiscal?.periodo ?? ''} - ${g?.periodos_vacacionales?.periodo ?? ''} (${g?.fecha_inicial ?? ''} - ${g?.fecha_final ?? ''})`,
              }))}
            />
          </Form.Item>
          <Form.Item label="Usuario">
            <Input
              value={user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() : ''}
              disabled
            />
          </Form.Item>
        </Form>
      </Modal>
      <ModalDelete
        open={visibleEliminar}
        onDelete={eliminarVacacion}
        onCancel={() => setVisibleEliminar(false)}
        loading={loadingEliminar}
        content="el registro de vacaciones seleccionado"
      />
    </Row>
  );
};

export default VacacionesRegistros;
